module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('email-filter', {
    on: {
      "filterChanged": _vm.renderRelevantTxt,
      "statusChanged": _vm.renderRelevantStatus
    }
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.getEmails
    },
    on: {
      "row-click": _vm.selectEmail
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "subject",
      "label": "Subject",
      "width": "500"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89f36b4c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/email/EmailList.vue
// module id = 291
// module chunks = 1